import { css } from "@emotion/css";

const styles = {
  details: css`
    height: 50px;
  `,
};

export default styles;
